import type { ReactNode } from 'react';

/**
 * Label/value row. `latin` marks values that are Latin script — serials,
 * personal numbers, uids — which must be isolated from the surrounding RTL run
 * or the bidi algorithm reverses them (REQUIREMENTS §2.8).
 */
export function Field({
  label,
  children,
  latin = false,
}: {
  label: string;
  children: ReactNode;
  latin?: boolean;
}) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-1.5">
      <dt className="shrink-0 text-sm text-slate-500">{label}</dt>
      <dd className={`text-sm font-medium text-slate-900 ${latin ? 'latin-inline' : ''}`}>
        {children}
      </dd>
    </div>
  );
}
